module.exports = __webpack_public_path__ + "static/media/modern-apartment.53acfc7d.jpg";